import React from "react";

/**
 * BrowserFrame — premium browser mockup wrapper.
 *
 * Renders a top window bar with traffic-light dots and a URL pill, then
 * the supplied screenshot/element below. Includes soft shadow, gold rim,
 * and optional hover-tilt for use inside carousels.
 */
const BrowserFrame = ({
  url,
  src,
  alt = "",
  children,
  className = "",
  rounded = "rounded-xl",
  showBar = true,
}) => {
  const hostname = (() => {
    try {
      if (!url) return "";
      const u = new URL(url.startsWith("http") ? url : `https://${url}`);
      return u.hostname.replace(/^www\./, "");
    } catch {
      return url || "";
    }
  })();

  return (
    <div
      className={`relative overflow-hidden ${rounded} ${className}`}
      style={{
        border: "1px solid rgba(212,175,55,0.22)",
        background: "rgba(8,8,8,0.85)",
        boxShadow:
          "0 24px 60px -10px rgba(0,0,0,0.7), 0 0 0 1px rgba(212,175,55,0.06), 0 0 48px rgba(212,175,55,0.08)",
      }}
    >
      {showBar && (
        <div
          className="flex items-center gap-3 px-4 py-2.5 border-b border-white/5"
          style={{
            background:
              "linear-gradient(to bottom, rgba(20,20,20,0.95), rgba(10,10,10,0.95))",
          }}
        >
          <div className="flex gap-1.5">
            <span className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]/80" />
            <span className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]/80" />
            <span className="w-2.5 h-2.5 rounded-full bg-[#28C840]/80" />
          </div>
          <div className="flex-1 mx-3">
            <div
              className="text-[10px] tracking-[0.18em] text-white/55 px-3 py-1 rounded-full text-center"
              style={{
                background: "rgba(0,0,0,0.45)",
                border: "1px solid rgba(212,175,55,0.18)",
              }}
            >
              <span className="text-gold/70">●</span>{" "}
              <span className="font-mono">{hostname}</span>
            </div>
          </div>
          <div className="w-12" aria-hidden />
        </div>
      )}
      <div className="relative">
        {src ? (
          <img
            src={src}
            alt={alt}
            className="block w-full h-auto"
            loading="lazy"
            draggable="false"
          />
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default BrowserFrame;
